import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppService } from './utils/services/app.service';
import { ApiService } from './utils/services/api.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { MenuSidebarComponent } from './main/menu-sidebar/menu-sidebar.component';
import { HeaderComponent } from './main/header/header.component';
import { BlankComponent } from './main/pages/blank/blank.component';
import { AgencyAddComponent } from './main/pages/agency-add/agency-add.component';
import { OrganizationAddComponent } from './main/pages/organization-add/organization-add.component';
import { OptionsService } from './utils/services/options.service';
import { OrganizationListComponent } from './main/pages/organization-list/organization-list.component';
import { OrganizationDetailComponent } from './main/pages/organization-detail/organization-detail.component';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { ModalModule } from 'ngx-modialog';
import { FlightProviderInfoComponent } from './main/frames/flight-provider-info/flight-provider-info.component';
import { DepositComponent } from './main/frames/deposit/deposit.component';
import { CrossParametersComponent } from './main/frames/cross-parameters/cross-parameters.component';
import { AgencySelectionComponent } from './shared/agency-selection/agency-selection.component';
import { OrganizationParameterComponent } from './main/frames/organization-parameter/organization-parameter.component';
import { AuthenticationInterceptorService } from './utils/services/authentication.service';
import { OrganizationResolverService } from './main/pages/organization-detail/resolvers/organization-resolver.service';
import { OrganizationAgencyResolverService } from './main/pages/organization-detail/resolvers/organization-agency-resolver.service';
import { CreditCardInfoComponent } from './main/frames/credit-card-info/credit-card-info.component';
import { CreditCardComponent } from './main/frames/credit-card/credit-card.component';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DepositResolverService } from './main/frames/deposit/resolver/deposit-resolver.service';
import { ProviderResolverService } from './main/frames/resolvers/provider-resolver.service';
import { DomainsComponent } from './main/frames/domains/domains.component';
import { DomainInfoComponent } from './main/frames/domain-info/domain-info.component';
import { AuthUserGuardService } from './utils/services/guards/auth-user-guard.service';
import { UserRoleGuardService } from './utils/services/guards/user-role-guard.service';
import { CrossParameterResolverService } from './main/frames/cross-parameters/resolver/cross-parameter-resolver.service';
import { ProviderCharacteristicResolverService } from './main/pages/provider-characteristic/resolver/provider-characteristic-resolver.service';
import { ProviderCharacteristicComponent } from './main/pages/provider-characteristic/provider-characteristic.component';
import { SystemHotelsComponent } from './main/pages/system-hotels/system-hotels.component';
import { MasterkeyComponent } from './main/pages/masterkey/masterkey.component';
import { DragAndDropFileModule } from './shared/drag-and-drop-file/drag-and-drop-file.module';
import { SelectFileModule } from './shared/select-file/select-file.module';
import { ParameterService } from './utils/services/parameter.service';
import { NgbModule, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { LocalizeDateModule } from './shared/date-localization/localize-date.module';
import { SystemHotelRequestsComponent } from './main/pages/system-hotel-requests/system-hotel-requests.component';
import { ImageLoaderModule } from './shared/image-loader/image-loader.module';
import { StarRatingModule } from './shared/star-rating/star-rating.module';
import { HotelDetailComponent } from './main/pages/hotel-detail/hotel-detail.component';
import { GoogleMapModule } from './shared/google-map/google-map.module';
import { GoogleAutocompleteInputModule } from './shared/google-autocomplete-input/google-autocomplete-input.module';
import { ItemSliderModule } from './shared/item-slider/item-slider.module';
import { NgxGalleryModule } from 'ngx-gallery';
import { ParentAgencyComponent } from './main/frames/parent-agency/parent-agency.component';
import { AgencyProvidersComponent } from './main/frames/agency-providers/agency-providers.component';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { ParameterResolverService } from './main/frames/resolvers/parameter-resolver.service';
import { CityDropdownModule } from './shared/city-dropdown/city-dropdown.module';
import { HotelRegisterRequestsComponent } from './main/pages/hotel-register-requests/hotel-register-requests.component';
import { FreeHotelChangesComponent } from './main/pages/free-hotel-changes/free-hotel-changes.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RoomChangesComponent } from './main/pages/room-changes/room-changes.component';
import { RoomModalComponent } from './main/pages/room-changes/room-modal/room-modal.component';
import { FreeHotelModalComponent } from './main/pages/free-hotel-changes/free-hotel-modal/free-hotel-modal.component';
import { ImageChangesComponent } from './main/pages/image-changes/image-changes.component';
import { KeyvalueModule } from './shared/keyvalue/keyvalue.module';
import { HotelChangesItemComponent } from './main/pages/free-hotel-changes/hotel-changes-item/hotel-changes-item.component';
import { ModalComponent } from './main/pages/hotel-register-requests/modal/modal.component';
import { HotelDropdownModule } from './shared/hotel-dropdown/hotel-dropdown.module';
import { UsersComponent } from './main/frames/users/users.component';
import { UserDropdownModule } from './shared/user-dropdown/user-dropdown.module';
import { BankBinNumbersComponent } from './main/pages/bank-bin-numbers/bank-bin-numbers.component';
import { BankBinNumberInfoModalComponent } from './main/pages/bank-bin-numbers/bank-bin-number-info-modal/bank-bin-number-info-modal.component';
import { DialogModalModule } from './shared/dialog-modal/dialog-modal.module';
import { TvLoginComponent } from './main/frames/tv-login/tv-login.component';
import {CountryDropdownModule} from './shared/country-dropdown/country-dropdown.module';
import { KvkkComponent } from './main/frames/kvkk/kvkk.component';
import { WhatsNewListComponent } from './main/pages/whats-new/whats-new-list/whats-new-list.component';
import { WhatsNewEditorComponent } from './main/pages/whats-new/whats-new-editor/whats-new-editor.component';
import { WhatsNewFeedbacksComponent } from './main/pages/whats-new/whats-new-feedbacks/whats-new-feedbacks.component';
import { WhatsNewPreviewComponent } from './main/pages/whats-new/whats-new-preview/whats-new-preview.component';

export const modalConfig: NgbModalOptions = {
  backdrop: 'static'
}

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule.forRoot(),
    BootstrapModalModule,
    SimpleNotificationsModule.forRoot(),
    DragAndDropFileModule,
    SelectFileModule,
    NgbModule.forRoot(),
    LocalizeDateModule,
    KeyvalueModule,
    ImageLoaderModule,
    StarRatingModule,
    GoogleMapModule,
    GoogleAutocompleteInputModule,
    ItemSliderModule,
    NgxGalleryModule,
    SelectDropDownModule,
    CityDropdownModule,
    HotelDropdownModule,
    InfiniteScrollModule,
    UserDropdownModule,
    DialogModalModule,
    CountryDropdownModule
  ],
  declarations: [
    AppComponent,
    MenuSidebarComponent,
    HeaderComponent,
    BlankComponent,
    AgencyAddComponent,
    OrganizationAddComponent,
    LoginComponent,
    MainComponent,
    OrganizationListComponent,
    OrganizationDetailComponent,
    FlightProviderInfoComponent,
    DepositComponent,
    CrossParametersComponent,
    AgencySelectionComponent,
    OrganizationParameterComponent,
    CreditCardInfoComponent,
    CreditCardComponent,
    DomainsComponent,
    DomainInfoComponent,
    ProviderCharacteristicComponent,
    SystemHotelsComponent,
    MasterkeyComponent,
    SystemHotelRequestsComponent,
    HotelDetailComponent,
    ParentAgencyComponent,
    AgencyProvidersComponent,
    HotelRegisterRequestsComponent,
    FreeHotelChangesComponent,
    RoomChangesComponent,
    RoomModalComponent,
    FreeHotelModalComponent,
    ImageChangesComponent,
    HotelChangesItemComponent,
    ModalComponent,
    UsersComponent,
    BankBinNumbersComponent,
    BankBinNumberInfoModalComponent,
    TvLoginComponent,
    KvkkComponent,
    WhatsNewListComponent,
    WhatsNewEditorComponent,
    WhatsNewFeedbacksComponent,
    WhatsNewPreviewComponent
  ],
  providers: [
    AppService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptorService,
      multi: true
    },
    ApiService,
    OptionsService,
    OrganizationResolverService,
    OrganizationAgencyResolverService,
    DepositResolverService,
    ProviderResolverService,
    AuthUserGuardService,
    UserRoleGuardService,
    CrossParameterResolverService,
    ProviderCharacteristicResolverService,
    ParameterService,
    ParameterResolverService
  ],
  entryComponents: [
    FlightProviderInfoComponent,
    CreditCardInfoComponent,
    DomainInfoComponent,
    ModalComponent,
    RoomModalComponent,
    FreeHotelModalComponent,
    BankBinNumberInfoModalComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/app.module.ts